import script from "./StreamBarcodeReader.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamBarcodeReader.vue?vue&type=script&setup=true&lang=js"

import "./StreamBarcodeReader.vue?vue&type=style&index=0&id=374cc758&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/ReftabHelperWww/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-374cc758"]])

export default __exports__